import Navbar from "./Navbar";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="flex min-h-screen flex-col bg-brand-surface font-body text-brand-ink antialiased">
      <Navbar />
      <main className="w-full flex-1 pt-16">{children}</main>
      <Footer />
    </div>
  );
}
